<template>
  <v-card>
    <v-card-title class="headline py-2">
      Информация о {{isFolder?'папке':'файле'}}
      <v-spacer></v-spacer>
      <v-btn icon @click="$emit('close-dialog')" class="mx-0"><v-icon>close</v-icon></v-btn>
    </v-card-title>
    <v-divider></v-divider>
    
    <v-card-text class="pt-0">
      <table class="mb-3">
        <tr class="mb-1"> <td><b>Название</b></td> <td class="pl-2">{{data.name}}</td> </tr>
        <tr class="mb-1"> <td><b>Описание</b></td> <td class="pl-2">{{data.description || '-'}}</td> </tr>
        <tr class="mb-1"> <td><b>Размер</b></td> <td class="pl-2">{{formatFileSize(data.size)}}</td> </tr>
        <tr class="mb-1"> <td><b>Дата создания</b></td> <td class="pl-2">{{formatDatetime(data.created_at).middle}}</td> </tr>
        <tr class="mb-1"> <td><b>Дата обновления</b></td> <td class="pl-2">{{formatDatetime(data.updated_at).middle}}</td> </tr>
        <tr class="mb-1" v-if="data.deleted_at"> <td><b>Дата удаления</b></td> <td class="pl-2">{{formatDatetime(data.deleted_at).middle}}</td> </tr>
      </table>
      <v-text-field v-if="isFile" slot="activator" id="fileLink" label="Ссылка на файл" readonly :value="link"
                    append-icon="mdi-clipboard-outline" @click:append="copyToClipboard" />
    </v-card-text>
  </v-card>
</template>

<script>
  import { mapGetters } from 'vuex'
  
  export default {
    name : "InfoForm",
    
    props:{
      data:{
        type: Object,
        required: true
      },
      type:{
        type: String,
        required: true
      }
    },
    
    computed:{
      isFolder(){
        return this.type==='folder'
      },
      isFile(){
        return this.type==='file' && this.data.token
      },
      ...mapGetters('app/helpers',['formatDatetime']),
      link(){
        return "https://dantser.net/disk/d/"+this.data.token
      }
    },
    
    methods:{
      copyToClipboard(){
        document.getElementById("fileLink").select()
        document.execCommand("copy");
        this.$dmsSuccessNoty('Ссылка скопирована!')
      },
  
      formatFileSize(bytes) {
        if(isNaN(bytes)) return '-'
        if(bytes===0) return ' 0 Б'
        let k = 1000,
          dm = 2,
          sizes = ['Б', 'Кб', 'Мб', 'Гб', 'Тб', 'Пб'],
          i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i]
      }
    }
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/apps/disk/components/Folders/Forms/InfoForm.vue